
import React from 'react';
import BlogImageGallery from "@/components/blog/BlogImageGallery";
import { Camera, MapPin } from "lucide-react";

const ValoGuideGallery = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-fabre-lightgray to-white">
      <div className="container mx-auto px-4">
        <header className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Camera className="w-8 h-8 text-fabre-green mr-3" />
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-fabre-gray">
              Galerie Photos de nos Sites
            </h2>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-6">
            Découvrez en images nos installations, nos équipements et notre savoir-faire 
            dans la valorisation des déchets à travers notre réseau de sites.
          </p>
          <div className="flex items-center justify-center text-sm text-gray-500">
            <MapPin className="w-4 h-4 mr-1" />
            <span>Sites répartis sur toute la France</span>
          </div>
        </header>
        <div className="bg-white rounded-lg shadow-lg p-6">
          <BlogImageGallery showTitle={false} />
        </div>
      </div>
    </section>
  );
};

export default ValoGuideGallery;
